import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import { globalModel } from "../../global/GlobalModel";
import { useCustomerServiceChatModal } from "../../components/customer-service-chat/CustomerServiceChatModalProvider";
import { CustomerServiceTextEntry } from "../../components/customer-service-chat/CustomerServiceEntry";
import { SITE_FOOTER } from "./siteFooterContent";
import "./SiteFooter.css";

/**
 * 全站底栏：法规链接、公司主体与备案号（icp / police 见 siteFooterContent）
 */
export const SiteFooter = observer(function SiteFooter() {
  const cs = useCustomerServiceChatModal();
  const icpBody = SITE_FOOTER.icpLabel || "待补充";
  const policeBody = SITE_FOOTER.policeLabel || "待补充";

  return (
    <footer className="site-footer" role="contentinfo">
      <nav className="site-footer-nav" aria-label="法律与平台规则">
        <Link className="site-footer-link" to="/legal/user-agreement">
          用户协议
        </Link>
        <span className="site-footer-sep" aria-hidden>
          |
        </span>
        <Link className="site-footer-link" to="/legal/privacy">
          隐私政策
        </Link>
        <span className="site-footer-sep" aria-hidden>
          |
        </span>
        <Link className="site-footer-link" to="/legal/compliance">
          法律合规
        </Link>
        <span className="site-footer-sep" aria-hidden>
          |
        </span>
        <Link className="site-footer-link" to="/legal/creator">
          大V入驻规则
        </Link>
        <span className="site-footer-sep" aria-hidden>
          |
        </span>
        <Link className="site-footer-link" to="/creator-apply">
          我是大V
        </Link>
        {globalModel.isLoggedIn ? (
          <>
            <span className="site-footer-sep" aria-hidden>
              |
            </span>
            <CustomerServiceTextEntry
              className="site-footer-link"
              onClick={cs.openCustomerServiceChat}
            />
          </>
        ) : null}
      </nav>
      <p
        className="site-footer-meta"
        role="group"
        aria-label="公司主体与备案信息"
      >
        <span className="site-footer-company-inrow">{SITE_FOOTER.companyName}</span>
        <span className="site-footer-sep" aria-hidden>
          |
        </span>
        <span>
          <span className="site-footer-beian-label">ICP 许可证：</span>
          {SITE_FOOTER.icpLabel ? (
            <a
              className="site-footer-link"
              href={SITE_FOOTER.icpQueryUrl}
              target="_blank"
              rel="noreferrer noopener"
            >
              {icpBody}
            </a>
          ) : (
            <span className="site-footer-beian-pending">{icpBody}</span>
          )}
        </span>
        <span className="site-footer-sep" aria-hidden>
          |
        </span>
        <span>
          <span className="site-footer-beian-label">公安网备：</span>
          {SITE_FOOTER.policeLabel ? (
            <a
              className="site-footer-link"
              href={SITE_FOOTER.policeQueryUrl}
              target="_blank"
              rel="noreferrer noopener"
            >
              {policeBody}
            </a>
          ) : (
            <span className="site-footer-beian-pending">{policeBody}</span>
          )}
        </span>
      </p>
    </footer>
  );
});
